import { Link, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingBag } from "lucide-react";
import { useCartTotals } from "../../lib/cart";
import { formatPrice } from "../../data/siteData";

export const FloatingCart = () => {
  const { pathname } = useLocation();
  const { count, total } = useCartTotals();
  const show = count > 0 && !pathname.startsWith("/commander-a-emporter") && !pathname.startsWith("/commande");
  return (
    <AnimatePresence>
      {show && (
        <motion.div initial={{ y: 80, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: 80, opacity: 0 }} className="fixed bottom-5 inset-x-0 z-40 flex justify-center px-4 pointer-events-none">
          <Link to="/commander-a-emporter" className="pointer-events-auto btn-gold shadow-[0_20px_50px_-15px_rgba(0,0,0,0.8)]" data-testid="floating-cart-button">
            <ShoppingBag className="w-4 h-4" /> Panier ({count}) · {formatPrice(Math.round(total * 100) / 100)}
          </Link>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
